import React from "react";

const ChatbotButton = ({
  onClick,
  color = "#000000",
  position = "bottomRight",
}) => {
  return (
    <button
      id="chatbutton"
      className={`chatbuttonhover ${position}`}
      onClick={onClick}
      style={{ backgroundColor: color }}>
      <img
        src="https://jaano.ai/chat.svg"
        alt="Chat Logo"
        style={{ width: "80%", height: "80%", margin: 0, zIndex: 9999 }}
      />
    </button>
  );
};

export default ChatbotButton;
